const Set_User_Listing = (state, users) => {
  state.users = users;
};

const Set_User = (state, user) => {
  state.user = user;
};

export default {
  Set_User,
  Set_User_Listing
};
